import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import Slider from "react-slick";
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Advantages from './Advantages';
import "./arrows.css"
import Carousel from './carousel';
import theme from 'ui/styles/theme';
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'
import withTranslations from 'containers/withTranslations'
import LocalizedString from 'ui/components/generic/LocalizedString'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'


// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


class ProductPage extends Component {
    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.state = {
            nav1: null,
            nav2: null,
            nav3: null,
            picture: '',
            show: false,
            isMobile: false,
            clickedSlide: 0,
            activeSlide: 0,
            activeSlide2: 0,
            downloads: false,
            windowLocation: '',
            urlLocate: '',
            urlWhere: '',
            urlTechnical: ''
        }

    }

    componentDidMount = () => {

        this.checkUrls(this.props);
        //Detect a click outside of an element
        document.addEventListener("mousedown", this.handleClickOutside);
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        })
        this.detectMobile();
        this.setState({ windowLocation: window.location.href })
        if (document.getElementById('downloads')) {
            this.setState({ downloads: true })
        } else {
            this.setState({ downloads: false })
        }
        let vid = document.getElementsByClassName('yt-slider-vid');
    }
    //Handle what happens when the click outside of an element is detected
    handleClickOutside(event) {
        if (this.state.show === true) {
            if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
                this.setState({ show: false })
            }
        }

    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    detectMobile = () => {
        const width = window.innerWidth
        const isMobile = width <= theme.grid.breakpoints.md

        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile })
        }
    }

    getCurrentUrl = () => {
        let baseURL = 'https://www.facebook.com/sharer/sharer.php';
        let myURL = new URL(baseURL);
        myURL.searchParams.append('u', this.state.windowLocation);
        return myURL.href;
    }

    imageSet = (e, key) => {
        /* let el = document.getElementsByClassName('slick-current')[0]
        let styledEl = el.querySelectorAll('div')[2]
        let image = getComputedStyle(styledEl).backgroundImage
        let sliced = image.slice(5, -2) */
        this.setState({ show: true, clickedSlide: key })
    }

    closeCarousel = (childData) => {
        this.setState({ show: childData });
        if (this.state.show === true) {
            this.setState({ show: !this.state.show })
        }
    }

    //Check if URL has been added in the background. If not it will fallback to the /contact page.
    //It's neccessary so page doesn't break after update and all of the URLs will be empty
  /* checkUrls = (props) => {
    let conUrl = "/contact"
    Object.entries(props.urls).forEach(([key, value]) => {
        if (value === null) {
            switch (key) {
                case 'where_to_buy_url':
                    this.setState({ urlWhere: conUrl });
                    break;
                case 'locate_a_dealer_url':
                    this.setState({ urlLocate: conUrl });
                    break;
                case 'technical_info_url':
                    this.setState({ urlTechnical: conUrl });
                    break;
                default:
                    break;
            }
        } else if (value !== null) {
            
        }
    });
}*/

checkUrls = (props) => {
    let conUrl = "/contact";
    const urlMapping = {
        'urlWhere': 'urlWhere',
        'urlLocate': 'urlLocate',
        'urlTechnical': 'urlTechnical'
    };

    // Iterate over the entries in the urls object
    Object.entries(props.urls).forEach(([key, value]) => {
        // Check if the key is one of the expected keys by looking it up in the urlMapping
        if (urlMapping[key]) {
            // Set the state for the corresponding mapped key
            // Use the actual value if it's not null, otherwise use conUrl
            this.setState({ [urlMapping[key]]: value !== null ? getRelativeUrl(value.link) : conUrl });
        }
    });
}




    showSetter = () => {
        this.setState(prevState => ({ show: !prevState.show }))
    }

    render() {
        const {
            title,
            bodyText,
            pictures,
            advantagesText,
            advantagesBodyText,
            advantagesImage,
            certificates,
            advantages,
            urls

        } = this.props

        const { picture, show, activeSlide, downloads, windowLocation, urlLocate, urlTechnical, urlWhere } = this.state

        const sliderSettings = {
            fade: true,
            asNavFor: this.state.nav2,
            ref: slider => (this.slider1 = slider),
            arrows: false,
            beforeChange: (current, next) => this.setState({ activeSlide: next }),
            afterChange: current => this.setState({ activeSlide2: current })
        }

        const settings = {
            dots: false,
            asNavFor: this.state.nav1,
            ref: slider => (this.slider2 = slider),
            slidesToShow: pictures.length > 3 ? pictures.length - 1 : pictures.length,
            focusOnSelect: true,
            infinite: true,
            slidesToScroll: 1,
            arrows: pictures.length > 3 && this.state.isMobile !== true ? true : false,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        }

        const sliderSettings2 = {
            fade: true,
            asNavFor: this.state.nav1,
            ref: slider => (this.slider3 = slider),
            arrows: true,
            dots: true
        }


        return (
            <Wrapper>
                <Opacity kupka={show} onClick={undefined}>
                    {show &&
                        <Carousel image={picture} pictures={pictures} parentCallback={this.closeCarousel} start={activeSlide} innerRef={this.wrapperRef} />
                    }
                </Opacity>
                <HeroWrapper fluid>
                    <Row>
                        <Col
                            lg={5}
                        >
                            <ImageContainer>
                                <Slider {...sliderSettings}>
                                    {pictures.map((item, index) =>
                                        <ImgSlide key={index} onClick={event => this.imageSet(event, index)}>
                                            <Image image={item.image.sourceUrl} />
                                        </ImgSlide>
                                    )}
                                </Slider>
                                <Slider {...settings} className="slider-custom">
                                    {pictures.map((item, index) =>
                                        <div key={index} style={'margin: 0 -10px'}>
                                            <Pic image={item.image.sourceUrl} />
                                        </div>
                                    )}
                                </Slider>
                            </ImageContainer>
                        </Col>
                        <Col
                            lg={7}
                        >
                            <TextContainer>
                                <Title>
                                    {title}
                                </Title>
                                <Text dangerouslySetInnerHTML={{ __html: bodyText }} />
                                <BottomText>
                                    <Certificate>
                                        {certificates &&
                                            <CertImg image={certificates.sourceUrl} />
                                        }
                                    </Certificate>
                                    <WhereBuy to={urlWhere}>
                                        <LocalizedString group="pageContent" string="where_to_buy_button" />
                                    </WhereBuy>
                                </BottomText>
                            </TextContainer>
                        </Col>
                    </Row>
                    <ButtonWrapper>
                        <FlexWrapper>
                            {downloads === true ?
                                <a href='#downloads'>
                                    <DownloadButton>
                                        <LocalizedString group="pageContent" string="downloads_button" />
                                    </DownloadButton>
                                </a>
                                :
                                <ButtonLink to={urlTechnical}>
                                    <DownloadButton>
                                        <LocalizedString group="pageContent" string="downloads_button" />
                                    </DownloadButton>
                                </ButtonLink>
                            }
                            <ButtonLink to={urlLocate} style={{ textDecoration: 'none' }}>
                                <LocateADealer>
                                    <div><LocalizedString group="pageContent" string="locate_a_dealer_button" /></div>
                                    <Icon>
                                        <svg
                                            id="Layer_1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="-12 0 72 80">
                                            <path
                                                d="M43.72,22.64c0,11.64-21.09,44.22-21.09,44.22,0,0-21.09-32.58-21.09-44.22S10.99,1.55,22.64,1.55s21.09,9.44,21.09,21.09Z"
                                                fill="none"
                                                stroke="#fff"
                                                strokeMiterlimit="10"
                                                strokeWidth="3.1px" />
                                            <circle
                                                cx="22.64" cy="23" r="9.19"
                                                fill="none"
                                                stroke="#fff"
                                                strokeMiterlimit="10"
                                                strokeWidth="3.1px" />
                                        </svg>

                                    </Icon>
                                </LocateADealer>
                            </ButtonLink>
                        </FlexWrapper>
                        <FlexWrapper>
                            <SoMe href={this.getCurrentUrl()}>
                                <svg
                                    width="8"
                                    height="18"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M.168 6.288h1.657V4.674c0-.712.017-1.81.534-2.49.543-.719 1.29-1.209 2.574-1.209 2.09 0 2.972.3 2.972.3l-.414 2.46s-.692-.2-1.336-.2c-.645 0-1.222.23-1.222.877v1.876h2.644L7.392 8.69H4.933v8.35H1.825V8.69H.168V6.288z"
                                        fill="#FEFEFE"
                                        fillRule="evenodd"
                                    />
                                </svg>
                            </SoMe>
                            <SoMe href={'https://www.linkedin.com/sharing/share-offsite/?url=' + windowLocation}>
                                <svg
                                    width="17"
                                    height="15"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.054 14.726h-3.545V9.54c0-1.358-.553-2.284-1.773-2.284-.933 0-1.451.625-1.693 1.228-.09.216-.076.516-.076.819v5.422H5.456s.046-9.185 0-10.02h3.511v1.572c.207-.687 1.33-1.668 3.12-1.668 2.221 0 3.967 1.44 3.967 4.544v5.572zM1.905 3.452h-.022C.752 3.452.017 2.686.017 1.716c0-.99.757-1.74 1.91-1.74S3.79.724 3.813 1.713c0 .97-.732 1.739-1.907 1.739zM.422 14.726h3.126V4.706H.422v10.02z"
                                        fill="#FEFEFE"
                                        fillRule="evenodd" />
                                </svg>
                            </SoMe>
                            <div style={{ alignSelf: "center" }}><LocalizedString group="pageContent" string="share" /></div>
                        </FlexWrapper>
                    </ButtonWrapper>
                </HeroWrapper>
                {advantagesText &&
                    <AdvantagesWrapper>
                        <AdvantageTitle>{advantagesText}</AdvantageTitle>
                        <Advantages icons={advantages} />
                        {advantagesImage &&
                            <AdvantageImg image={advantagesImage.sourceUrl}></AdvantageImg>
                        }
                    </AdvantagesWrapper>
                }
            </Wrapper>
        )
    }
}
export default compose(
    withRouter,
    withTranslations()
)(ProductPage)

const Wrapper = styled.section`
                    margin-top: 20%;

                    ${media.lg`
                    margin-top: 7%;
                    `}
                    `

const Opacity = styled.div`
                    width: ${props => props.kupka === true ? '100vw' : '0vw'};
                    height: ${props => props.kupka === true ? '100vh' : '0vh'};
                    background-color: rgba(0,0,0,0.8);
                    position: fixed;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 1111;
                    opacity: ${props => props.kupka === true ? '1' : '0'}
                    transition: opacity 0.5s;
                    `

const FlexWrapper = styled.div`
                    display: flex;
                    gap: 10px;
                    `

const ButtonLink = styled(Link)`
`

const ButtonWrapper = styled.section`
                    display: flex;
                    margin: 3% 0;
                    justify-content: flex-start;
                    align-items: initial;
                    gap: 10px;
                    padding: 4% 0;
                    flex-wrap: wrap;

                    ${media.lg`
                    align-items: stretch;
                    padding: 2% 0;
                    `}
                    `
const DownloadButton = styled.button`
                    background-color: #00994c;
                    color: white;
                    border: none;
                    border-radius: 3px;
                    padding: 5px 15px;
                    font-size: 0.9em;
                    text-transform: uppercase;
                    transition: all 0.2s;
                    height: 100%;


                    &:hover {
                        transform: scale(1.02);
                    background-color: rgba(0, 153, 76, 0.68) !important;
}
                    `
const LocateADealer = styled.button`
                    background-color: rgba(21, 21, 21, 0.80);
                    display: flex;
                    color: white;
                    border: none;
                    border-radius: 3px;
                    padding: 5px 15px;
                    font-size: 0.9em;
                    text-transform: uppercase;
                    transition: all 0.2s;
                    height: 100%;
                    align-items: center;



                    &:hover {
                        transform: scale(1.02);
                    background-color: rgba(100, 100, 100, 0.68) !important;
}
                    `
const SoMe = styled.a`
                    display: flex;
                    background: #9BB4C8;
                    width: 32px;
                    height: 32px;
                    border-radius: 32px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-self: end;
                    `
const Icon = styled.div`
                    width: 22px;
                    height: 19px;
                    border-radius: 50%;
                    margin-left: 5px;
                    align-self: center;
                    `

const AdvantagesWrapper = styled.section`
                    background-color: #f5f5f5;
                    padding: 2% 8% 2% 8%;
                    margin-top: 2%;
                    margin-bottom: 2%;

                    ${media.md`
                    padding: 2% 0 2% 20%;
                    `}
                    `
const AdvantageTitle = styled.h2`
                    `
const AdvantageImg = styled.div`
                    background: url(${props => props.image}) center / cover;
                    width: 100%;
                    height: 150px;
                    `

const AdvantageText = styled.div`
                    margin: 2% 0;
                    `

const Certificate = styled.div`
                    width: 65%;
                    height: 35px;
                    `
const CertImg = styled.div`
                    background: url(${props => props.image}) center / contain;
                    width: 100%;
                    height: 100%;
                    background-repeat: no-repeat;
                    background-position: left;
                    `

const WhereBuy = styled(Link)`
                    background-color: #00994c;
                    color: white;
                    border: none;
                    border-radius: 3px;
                    padding: 5px 15px;
                    text-transform: uppercase;
                    font-size: 0.9em;
                    transition: all .2s;
                    text-decoration: none;
                    cursor: pointer;

                    &:hover {
                        transform: scale(1.02);
                    background-color: rgba(0, 153, 76, 0.68) !important;
                    color: white;
}
                    `


const BottomText = styled.div`
                    display: flex;
                    width: 100%;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: auto;
                    flex-wrap: wrap;
                    row-gap: 25px;
                    `

const HeroWrapper = styled(Container)`
                    padding: 0 20px;
                    ${media.lg`
                    padding: 0 20%;
                    `}
                    `

const Image = styled.div`
                    background: url(${props => props.image}) center / cover;
                    width: 100%;
                    height: 500px;
                    cursor: pointer;
                    `
const Title = styled.h1`
                    margin-top: 0 !important;
                    font-size: 40px;
                    `
const TextContainer = styled.div`
                    background-color: #f5f5f5;
                    padding: 2%;
                    display: flex;
                    height: 100%;
                    flex-direction: column;

                    ${media.md`

`}
                    `
const Text = styled.div`
                    font-weight: 300;
                    font-size: 22px;
                    line-height: 30px;

                    h2 {
                        margin: 0 !important;
}
                    h3 {
                        font-size: 35px !important;
                        margin-bottom: 1.3rem;
                    `
const ImageContainer = styled.div`

                    `
const ImgSlide = styled.div`
                    width: 100%;
                    height: 100%;
                    `
const Pic = styled.div`
                    height: 100px;
                    background: url(${props => props.image}) center / cover;
                    cursor: pointer;
                    margin: 0 10px;
                    `

const SampleNextArrow = styled.div`
                    &:before{
                        color: #004077 !important;
}
                    `
const SamplePrevArrow = styled.div`
                    &:before{
                        color: #004077 !important;
}
                    `



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductPage/index.js